import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { rootRoute } from "@/routes/rootRoute";

export const homeRoute = createRoute({
  path: "/home",
  getParentRoute: () => rootRoute,
  component: lazyRouteComponent(async () => {
    const m = await import("./Home");
    return { default: m.Home };
  }),
});
